'use client'

import { FC, useMemo } from 'react'
import { sanitizeHtml } from '@/root/shared-helpers/utils/utils'
import { Page } from '@/root/shared-types'
import { PageTitle } from '@/root/modules/tuuleliinid'
import { ContentContainer } from '@/root/ui/tuuleliinid'

export const DefaultPage: FC<Page> = ({ subject, body }) => {
  const sanitizedBody = useMemo(() => {
    return sanitizeHtml(body ?? '')
  }, [body])

  return (
    <ContentContainer>
      <PageTitle>{subject}</PageTitle>
      <div className="flex w-full flex-col gap-3 text-lg" dangerouslySetInnerHTML={{ __html: sanitizedBody }} />
    </ContentContainer>
  )
}
